/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiPenaltyDetailsCreatePenaltyDetailsPost } from '../fn/settings-penalty-details/api-penalty-details-create-penalty-details-post';
import { ApiPenaltyDetailsCreatePenaltyDetailsPost$Params } from '../fn/settings-penalty-details/api-penalty-details-create-penalty-details-post';
import { apiPenaltyDetailsCreatePenaltyDetailsPost$Plain } from '../fn/settings-penalty-details/api-penalty-details-create-penalty-details-post-plain';
import { ApiPenaltyDetailsCreatePenaltyDetailsPost$Plain$Params } from '../fn/settings-penalty-details/api-penalty-details-create-penalty-details-post-plain';
import { apiPenaltyDetailsDeletePenaltyDetailsDelete } from '../fn/settings-penalty-details/api-penalty-details-delete-penalty-details-delete';
import { ApiPenaltyDetailsDeletePenaltyDetailsDelete$Params } from '../fn/settings-penalty-details/api-penalty-details-delete-penalty-details-delete';
import { apiPenaltyDetailsDeletePenaltyDetailsDelete$Plain } from '../fn/settings-penalty-details/api-penalty-details-delete-penalty-details-delete-plain';
import { ApiPenaltyDetailsDeletePenaltyDetailsDelete$Plain$Params } from '../fn/settings-penalty-details/api-penalty-details-delete-penalty-details-delete-plain';
import { apiPenaltyDetailsGetPenaltiesDetailsPost } from '../fn/settings-penalty-details/api-penalty-details-get-penalties-details-post';
import { ApiPenaltyDetailsGetPenaltiesDetailsPost$Params } from '../fn/settings-penalty-details/api-penalty-details-get-penalties-details-post';
import { apiPenaltyDetailsGetPenaltiesDetailsPost$Plain } from '../fn/settings-penalty-details/api-penalty-details-get-penalties-details-post-plain';
import { ApiPenaltyDetailsGetPenaltiesDetailsPost$Plain$Params } from '../fn/settings-penalty-details/api-penalty-details-get-penalties-details-post-plain';
import { apiPenaltyDetailsUpdatePenaltyDetailsPatch } from '../fn/settings-penalty-details/api-penalty-details-update-penalty-details-patch';
import { ApiPenaltyDetailsUpdatePenaltyDetailsPatch$Params } from '../fn/settings-penalty-details/api-penalty-details-update-penalty-details-patch';
import { apiPenaltyDetailsUpdatePenaltyDetailsPatch$Plain } from '../fn/settings-penalty-details/api-penalty-details-update-penalty-details-patch-plain';
import { ApiPenaltyDetailsUpdatePenaltyDetailsPatch$Plain$Params } from '../fn/settings-penalty-details/api-penalty-details-update-penalty-details-patch-plain';
import { CreatePenaltyDetailsCommandResult } from '../models/create-penalty-details-command-result';
import { DeletePenaltyDetailsCommandResult } from '../models/delete-penalty-details-command-result';
import { GetPenaltiesDetailsQueryResult } from '../models/get-penalties-details-query-result';
import { UpdatePenaltyDetailsCommandResult } from '../models/update-penalty-details-command-result';

@Injectable({ providedIn: 'root' })
export class SettingsPenaltyDetailsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiPenaltyDetailsGetPenaltiesDetailsPost()` */
  static readonly ApiPenaltyDetailsGetPenaltiesDetailsPostPath = '/api/PenaltyDetails/GetPenaltiesDetails';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPenaltyDetailsGetPenaltiesDetailsPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPenaltyDetailsGetPenaltiesDetailsPost$Plain$Response(params?: ApiPenaltyDetailsGetPenaltiesDetailsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetPenaltiesDetailsQueryResult>> {
    return apiPenaltyDetailsGetPenaltiesDetailsPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPenaltyDetailsGetPenaltiesDetailsPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPenaltyDetailsGetPenaltiesDetailsPost$Plain(params?: ApiPenaltyDetailsGetPenaltiesDetailsPost$Plain$Params, context?: HttpContext): Observable<GetPenaltiesDetailsQueryResult> {
    return this.apiPenaltyDetailsGetPenaltiesDetailsPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetPenaltiesDetailsQueryResult>): GetPenaltiesDetailsQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPenaltyDetailsGetPenaltiesDetailsPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPenaltyDetailsGetPenaltiesDetailsPost$Response(params?: ApiPenaltyDetailsGetPenaltiesDetailsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetPenaltiesDetailsQueryResult>> {
    return apiPenaltyDetailsGetPenaltiesDetailsPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPenaltyDetailsGetPenaltiesDetailsPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPenaltyDetailsGetPenaltiesDetailsPost(params?: ApiPenaltyDetailsGetPenaltiesDetailsPost$Params, context?: HttpContext): Observable<GetPenaltiesDetailsQueryResult> {
    return this.apiPenaltyDetailsGetPenaltiesDetailsPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetPenaltiesDetailsQueryResult>): GetPenaltiesDetailsQueryResult => r.body)
    );
  }

  /** Path part for operation `apiPenaltyDetailsCreatePenaltyDetailsPost()` */
  static readonly ApiPenaltyDetailsCreatePenaltyDetailsPostPath = '/api/PenaltyDetails/CreatePenaltyDetails';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPenaltyDetailsCreatePenaltyDetailsPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPenaltyDetailsCreatePenaltyDetailsPost$Plain$Response(params?: ApiPenaltyDetailsCreatePenaltyDetailsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreatePenaltyDetailsCommandResult>> {
    return apiPenaltyDetailsCreatePenaltyDetailsPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPenaltyDetailsCreatePenaltyDetailsPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPenaltyDetailsCreatePenaltyDetailsPost$Plain(params?: ApiPenaltyDetailsCreatePenaltyDetailsPost$Plain$Params, context?: HttpContext): Observable<CreatePenaltyDetailsCommandResult> {
    return this.apiPenaltyDetailsCreatePenaltyDetailsPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreatePenaltyDetailsCommandResult>): CreatePenaltyDetailsCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPenaltyDetailsCreatePenaltyDetailsPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPenaltyDetailsCreatePenaltyDetailsPost$Response(params?: ApiPenaltyDetailsCreatePenaltyDetailsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreatePenaltyDetailsCommandResult>> {
    return apiPenaltyDetailsCreatePenaltyDetailsPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPenaltyDetailsCreatePenaltyDetailsPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPenaltyDetailsCreatePenaltyDetailsPost(params?: ApiPenaltyDetailsCreatePenaltyDetailsPost$Params, context?: HttpContext): Observable<CreatePenaltyDetailsCommandResult> {
    return this.apiPenaltyDetailsCreatePenaltyDetailsPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreatePenaltyDetailsCommandResult>): CreatePenaltyDetailsCommandResult => r.body)
    );
  }

  /** Path part for operation `apiPenaltyDetailsUpdatePenaltyDetailsPatch()` */
  static readonly ApiPenaltyDetailsUpdatePenaltyDetailsPatchPath = '/api/PenaltyDetails/UpdatePenaltyDetails';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPenaltyDetailsUpdatePenaltyDetailsPatch$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPenaltyDetailsUpdatePenaltyDetailsPatch$Plain$Response(params?: ApiPenaltyDetailsUpdatePenaltyDetailsPatch$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdatePenaltyDetailsCommandResult>> {
    return apiPenaltyDetailsUpdatePenaltyDetailsPatch$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPenaltyDetailsUpdatePenaltyDetailsPatch$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPenaltyDetailsUpdatePenaltyDetailsPatch$Plain(params?: ApiPenaltyDetailsUpdatePenaltyDetailsPatch$Plain$Params, context?: HttpContext): Observable<UpdatePenaltyDetailsCommandResult> {
    return this.apiPenaltyDetailsUpdatePenaltyDetailsPatch$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdatePenaltyDetailsCommandResult>): UpdatePenaltyDetailsCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPenaltyDetailsUpdatePenaltyDetailsPatch()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPenaltyDetailsUpdatePenaltyDetailsPatch$Response(params?: ApiPenaltyDetailsUpdatePenaltyDetailsPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdatePenaltyDetailsCommandResult>> {
    return apiPenaltyDetailsUpdatePenaltyDetailsPatch(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPenaltyDetailsUpdatePenaltyDetailsPatch$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPenaltyDetailsUpdatePenaltyDetailsPatch(params?: ApiPenaltyDetailsUpdatePenaltyDetailsPatch$Params, context?: HttpContext): Observable<UpdatePenaltyDetailsCommandResult> {
    return this.apiPenaltyDetailsUpdatePenaltyDetailsPatch$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdatePenaltyDetailsCommandResult>): UpdatePenaltyDetailsCommandResult => r.body)
    );
  }

  /** Path part for operation `apiPenaltyDetailsDeletePenaltyDetailsDelete()` */
  static readonly ApiPenaltyDetailsDeletePenaltyDetailsDeletePath = '/api/PenaltyDetails/DeletePenaltyDetails';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPenaltyDetailsDeletePenaltyDetailsDelete$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPenaltyDetailsDeletePenaltyDetailsDelete$Plain$Response(params?: ApiPenaltyDetailsDeletePenaltyDetailsDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DeletePenaltyDetailsCommandResult>> {
    return apiPenaltyDetailsDeletePenaltyDetailsDelete$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPenaltyDetailsDeletePenaltyDetailsDelete$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPenaltyDetailsDeletePenaltyDetailsDelete$Plain(params?: ApiPenaltyDetailsDeletePenaltyDetailsDelete$Plain$Params, context?: HttpContext): Observable<DeletePenaltyDetailsCommandResult> {
    return this.apiPenaltyDetailsDeletePenaltyDetailsDelete$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeletePenaltyDetailsCommandResult>): DeletePenaltyDetailsCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPenaltyDetailsDeletePenaltyDetailsDelete()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPenaltyDetailsDeletePenaltyDetailsDelete$Response(params?: ApiPenaltyDetailsDeletePenaltyDetailsDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<DeletePenaltyDetailsCommandResult>> {
    return apiPenaltyDetailsDeletePenaltyDetailsDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPenaltyDetailsDeletePenaltyDetailsDelete$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPenaltyDetailsDeletePenaltyDetailsDelete(params?: ApiPenaltyDetailsDeletePenaltyDetailsDelete$Params, context?: HttpContext): Observable<DeletePenaltyDetailsCommandResult> {
    return this.apiPenaltyDetailsDeletePenaltyDetailsDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeletePenaltyDetailsCommandResult>): DeletePenaltyDetailsCommandResult => r.body)
    );
  }

}
